import { connect } from 'react-redux';
import { OrientationOption } from './component';
import { getOrientationItems } from './selectors';
import { changePageOrientation } from '../actions';
const mapStateToProps = (state, props) => {
    return {
        // TODO zrusit selector a pocitat to primo v reducers/page
        value: state.page.orientation,
        items: getOrientationItems(state, props.locale),
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        onChange: (e) => {
            dispatch(changePageOrientation(e.target.value));
        },
    };
};
export const OrientationOptionContainer = connect(mapStateToProps, mapDispatchToProps)(OrientationOption);
//# sourceMappingURL=container.js.map